// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Al-z","articleImagesWrap":"Bl-z","articleImage":"Cl-z","singleImage":"Dl-z"};